import NoData from '../../../../../../components/NoData';
import floatToCurrency from '../../../../../../utils/floatToCurrency';
import { Card } from './styles';

interface RawEconomyInfoI {
  monthly: number;
  yearly: number;
}

export default function RawEconomyInfo({ monthly, yearly }: RawEconomyInfoI) {
  return (
    <Card>
      <div className="card-title">
        <div>Economia</div>
      </div>

      {!!monthly && (
        <>
          <div className="card-main" style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            alignItems: 'center',
            height: '100%',
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}>
              <div style={{fontSize: '32px'}}>
                {floatToCurrency(monthly)}
              </div>
              <small>
              Economia mensal
              </small>
            </div>

            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}>
              <div style={{fontSize: '32px'}}>
                {floatToCurrency(yearly)}
              </div>
              <small>
              Economia anual
              </small>
            </div>
          </div>
        </>
      )}

      {(!monthly) && (
        <NoData
          icon="emptyBox"
          label={(
            <>
              Não há dados sobre a economia mensal e anual
            </>
          )}
        />
      )}
    </Card>
  );
}
